import { Typography } from "@mui/material";
import { MainContainer } from "../MainContainerComp";

export const NoDataMessage = () => {
  return (
    <MainContainer hasGreyBg>
      <Typography 
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <Typography 
          sx={{
            display: 'flex',
            minHeight: '200px',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 4 
          }} 
          data-automation="no-data-msg"
        >
          No data
        </Typography>
      </Typography>
    </MainContainer>
  )
}